import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import Player from "@vimeo/player";
import { useAuth } from "../../Auth";
import SwiperPager from "../../controls/swiperPager";
import api from "../../services/api";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

// import required modules
import { Grid, Pagination } from "swiper/modules";
import arrow from "../../assets/images/icn-arrow-r.png";
import iconMembership from "../../assets/images/icn-benefits-guidemembership.png";
import iconWelcome from "../../assets/images/icn-benefits-welcome.png";
import iconReport from "../../assets/images/icn-benefits-report.png";
import iconLeadership from "../../assets/images/icn-benefits-guideleadership.png";
import iconOnboarding from "../../assets/images/icn-benefits-onboarding.png";
import iconDiagonalArrow from "../../assets/images/arrow-right-diagonal.png";
import iconUpArrow from "../../assets/images/icn-benefits-up.png";
import iconArrowDown from "../../assets/images/icn-benefits-down.png";
import iconArrowRight from "../../assets/images/icn-next-o.png";
import iconEmail from "../../assets/images/icn_email_blue.png";

const BenefitsElement = styled.section`
  display: flex;
  justify-content: center;
  padding: 57px 20px 52px 20px;
  background: #f1f1f1;
  .pagination {
    list-style: none;
    height: 31.5px;
    width: 31.5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto; /* Center the pagination horizontally */
    margin-top: 2px;
    cursor: pointer;
  }
  .pagination ul {
    gap: 0px!important;
  }
  .pagination li a {
    width: 25px !important;
    height: 25px !important;
    background-color: transparent;
    color: #333333;
    align-items: center;
    justify-content: center;
   
    cursor: pointer;
    text-align: center !important;
    font-size: 12px; /* Adjust font size as needed */
    line-height: .75; /* Ensure the number is properly contained within the box */
    padding:5px!important;
    padding-top:7px!important;
   
    margin: 5px;
    border: 1px solid #333333; /* Add a white border */
  }
  .pagination .break  a {
    border: 1px solid transparent!important; /* Add a white border */
  }
  .active a {
    background-color: #333333!important;
    color: #fff!important;
    
  }
  .hidden {
    display: none;
  }
  .cmp-benefits-container {
    max-width: 1154px;
    width: 100%;
  }

  .cmp-benefits-header {
    display: flex;
    align-items: center;
    margin-bottom: 25px;

    @media (max-width: 1100px) {
      flex-direction: column;
      align-items: flex-start;
    }

    .cmp-benefits-header-content {
      h2 {
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: -0.48px;
        color: #333333;
        margin-right: 40px;
      }

      p {
        font-size: 12px;
        line-height: 14px;
        font-weight: 500;
        color: #607588;
        margin-bottom: 5px;
      }
    }

    ul.cmp-benefits-tabs {
      display: flex;

      @media (max-width: 1100px) {
        margin-top: 22px;
      }

      li {
        &:not(:last-child) {
          margin-right: 53px;
          
          @media (max-width: 768px) {
            margin-right: 15px;
          }
        }
        @media (min-width: 1101px) {
      &:first-child:nth-last-child(2) {
        margin-left: 50px; // adjust this value as needed
      }
    }

        button {
          background: none;
          border: none;
          font-size: 18px;
          font-weight: 700;
          line-height: 21px;
          letter-spacing: -0.36px;
          color: #6a6d75;
          padding: 0;

          @media (max-width: 768px) {
            font-size: 18px;
            line-height: 17px;
          }

          span {
            color: #E2680E;
          }

          &:hover {
            color: #303440;
            cursor: pointer;
          }

          &.active {
            color: #303440;
            position: relative;

            &::after {
              content: " ";
              position: absolute;
              height: 3px;
              left: 0;
              right: 0;
              bottom: -10px;
              background: #2D66AC;
            }
          }
        }
      }
    }

    a {
      margin-left: auto;
      border-radius: 30px;
      background: #E2680E;
      border: 2px solid #E2680E;
      text-decoration: none;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0;
      padding: 4px 24px;
    }
  }

  .cmp-benefits-card {
    background-size: contain !important;
    background-repeat: no-repeat!important;
    background-position: 50% 50% !important;
    max-width: 365px;
    width: 100%;
    height: 240px;
    padding: 36px 33px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 7px;
    background: #fff;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    z-index: 2;
    pointer-events: auto;

    @media (max-width: 1100px) {
      max-width: 100%;
    }

    @media (max-width: 344px) {
      background-size: contain !important;
    }

    p.cmp-benefits-card-title {
      font-size: 18px;
      line-height: 21px;
      font-weight: 700;
      color: #303440;
      margin-bottom: 15px;
    }

    p.cmp-benefits-card-description {
      font-size: 14px;
      line-height: 22px;
      color: #303440;
    }

    a {
      font-size: 14px;
      line-height: 16px;
      color: #2D66AC;
      text-transform: uppercase;
      text-decoration: none;
      font-weight: 700;
      display: flex;
      align-items: center;
      margin-top: auto;
      margin-left: auto;

      img {
        height: 16px;
        width: 16px;
        margin-left: 10px;
        &.email {
          height:20px!important;
          width:20px!important;
        }
        &.access{
          height: 14px!important;
          width: 14px!important;
          margin-bottom:1px;
        }
      }
      
    }

    p,
    a {
      display: none;
    }

    // Desktop hover - disabled on mobile to prevent interference with touch
    @media (min-width: 769px) {
      &:hover {
        background-image: none !important;

        p {
          display: block;
        }

        a {
          display: flex;
          align-items: flex-end;
        }
      }
    }

    // Mobile flip functionality - show content when flipped
    @media (max-width: 768px) {
      // Disable hover on mobile devices first
      &:hover {
        background-image: inherit !important;
        
        p {
          display: none !important;
        }
        
        a {
          display: none !important;
        }
      }
      
      // Flipped state must override hover - higher specificity with !important
      &.flipped,
      &.flipped:hover {
        background-image: none !important;

        p {
          display: block !important;
        }

        a {
          display: flex !important;
          align-items: flex-end;
        }
      }
    }
  }

  .cmp-key-benefits {
    display: flex;
    align-items: center;

    @media (max-width: 1100px) {
      flex-direction: column;
    }

    .cmp-key-benefits-content {
      max-width: 338px;
      width: 100%;
      margin-right: 56px;
      position: relative;
      z-index: 0;

      @media (max-width: 1100px) {
        max-width: 100%;
        margin-right: unset;
        max-height:150px;
      }

      h3 {
        font-size: 24px;
        line-height: 28px;
        font-weight: 700;
        margin-bottom: 10px;
      }

      & > p {
        font-size: 16;
        line-height: 26px;
        color: #303440;
        padding-right: 12px;
      }

      .cmp-key-benefits-video-embed {
        margin-top: 43px;
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
        max-width: 100%;
        z-index: 0;
        pointer-events: none;

        @media (max-width: 1100px) {
          margin-top: 20px;
        }

        iframe,
        object,
        embed {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }

    .cmp-key-benefits-cards {
      max-width: 762px;
      width: 100%;
      align-self: flex-start;
      position: relative;
      z-index: 1;

      @media (max-width: 1100px) {
        max-width: 100%;
        margin-top: 32px;
      }

      ul {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 30px;
        grid-row-gap: 30px;

        @media (max-width: 680px) {
          grid-template-columns: 1fr;
        }

        li {
          position: relative;
          z-index: 1;
        }
      }
    }
  }

  .cmp-all-benefits {
    .swiper {
    }

    .swiper-wrapper {
      height: 562px;
    }

    .swiper-slide {
      height: unset;
    }

    .swiper-pagination {
      bottom: 0px;

      .swiper-pagination-bullet {
        height: 15px;
        width: 15px;
        background: none;
        border: 2px solid #707070;
        opacity: 1;

        &:not(:last-of-type) {
          margin-right: 10px;
        }

        &.swiper-pagination-bullet-active {
          background: #303440;
          border: 2px solid #303440;
        }
      }
    }
  }

  .cmp-member-resources {
    .cmp-member-resource-cards {
     /** ul {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 0px;
        grid-row-gap: 0px;

        @media (max-width: 1100px) {
          grid-template-columns: 1fr 1fr;
        }

        @media (max-width: 767px) {
          grid-template-columns: 1fr;
          grid-row-gap: 20px;
        }

        li {
        }
      }**/
    }
  }

  .cmp-member-resource-card {
    max-width: 365px;
    width: 100%;
    height: 240px;
    padding: 32px 25px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 7px;
    background: #fff;
    box-sizing: border-box;
    align-items: flex-start;
    cursor: pointer;
   
    position: relative; /* This allows for the positioning of the anchor */
    @media (max-width: 1100px) {
      max-width: 100%;
    }

    img.cmp-member-resource-card-icon {
      width: auto;
      height: 30px;
      margin-bottom: 15px;
    }

    p.cmp-member-resource-card-title {
      font-size: 18px;
      line-height: 21px;
      font-weight: 700;
      color: #303440;
      margin-bottom: 6px;
    }

    p.cmp-member-resource-card-description {
      font-size: 14px;
      line-height: 22px;
      color: #303440;
    }

    a {
      font-size: 14px;
      line-height: 16px;
      color: #2D66AC;
      text-transform: uppercase;
      text-decoration: none;
      font-weight: 700;
      display: flex;
      align-items: center;
      position: absolute; /* Anchor the link at a specific position */
      right: 25px; /* Align to the right */
      bottom: 25px; /* Align to the bottom */

      img {
        height: 16px;
        width: 16px;
        margin-left: 10px;
        
      }
      img.access{
          height: 14px!important;
          width: 14px;
        }
      
    }
  }
`;

const Benefits = () => {

  // Member Resource Icons
  const [currentSwiper, setCurrentSwiper] = useState(null);
  const [activeTab, setActiveTab] = useState("key-benefits");
  const [benefits, setBenefits] = useState("null");
  const [benefitsData, setBenefitsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabLoading, setTabLoading] = useState(false); // Separate loading state for tab switching
  const [flippedCards, setFlippedCards] = useState(new Set());
  const [isMobile, setIsMobile] = useState(false);
  const [loadedTabs, setLoadedTabs] = useState([]); // Track which tabs have been loaded

  const { cmpData, environment, cuesURL, canSectionLoad, markSectionLoaded } = useAuth();

  // Detect mobile on mount and window resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  function handleGAEvent(eventTitle, value) {
    if (cmpData) {
      // if (window.location.host == "mycues.cues.org") {
        // Push event to GTM data layer
        if (window.dataLayer) {
          window.dataLayer.push({
            event: eventTitle,
            event_category: 'Benefits',
            event_label: value,
            value: value,
            user_role: cmpData.account_info.acgiRole,
            user_memberlevel: cmpData.account_info.membershipLevel,
            user_company: cmpData.account_info.employer,
          });
        }
      // }
    }
  }

  // Generate unique ID for a card
  function getCardId(benefit, section) {
    // Use index if title is missing or use a combination for uniqueness
    const title = benefit.title || benefit.link || benefit.file || 'unknown';
    return `${section}-${title}`;
  }

  // Toggle flip state for a card
  function toggleCardFlip(benefit, section) {
    const cardId = getCardId(benefit, section);
    setFlippedCards(prev => {
      const newSet = new Set(prev);
      if (newSet.has(cardId)) {
        newSet.delete(cardId);
      } else {
        newSet.add(cardId);
      }
      return newSet;
    });
  }

  // Unflip a specific card
  function unflipCard(benefit, section) {
    const cardId = getCardId(benefit, section);
    setFlippedCards(prev => {
      const newSet = new Set(prev);
      if (newSet.has(cardId)) {
        newSet.delete(cardId);
      }
      return newSet;
    });
  }

  // Check if a card is flipped
  function isCardFlipped(benefit, section) {
    return flippedCards.has(getCardId(benefit, section));
  }

  function openBenefitLink(benefit, eventType, section) {
    let willNavigateAway = false;
    
    // Handle different link types with the same logic as the internal links
    if (benefit.linkType === "external_link") {
      const url = typeof benefit.link === 'string' ? benefit.link.replace("internal:", "") : benefit.link;
      const target = typeof benefit.link === 'string' && !benefit.link.startsWith('internal:#') ? "_blank" : "";
      
      if (target === "_blank") {
        window.open(url, '_blank');
        // Opens in new tab, user stays on page
        willNavigateAway = false;
      } else {
        window.location.href = url;
        // Navigates away from page
        willNavigateAway = true;
      }
      
      handleGAEvent(eventType, benefit.title);
    } else if (benefit.linkType === "download_link") {
      window.open(benefit.file, '_blank');
      // Opens in new tab, user stays on page
      willNavigateAway = false;
      handleGAEvent(eventType, benefit.title);
    } else if (benefit.linkType === "contact_link") {
      window.location.href = `mailto:${benefit.contact}`;
      // Mailto may or may not navigate, but typically stays on page
      willNavigateAway = false;
      handleGAEvent(eventType, benefit.title);
    }

    // Flip card back on mobile if user stays on page
    // Always unflip on mobile when link opens (unless navigating away)
    if (isMobile && !willNavigateAway && section) {
      // Unflip immediately, don't wait
      unflipCard(benefit, section);
    }
  }

  function handleCardClick(benefit, eventType, section) {
    // Prevent default behavior if clicking on a link inside the card
    if (eventType === 'link') {
      return;
    }

    // On mobile, toggle flip state instead of opening link immediately
    if (isMobile) {
      const cardId = getCardId(benefit, section);
      if (flippedCards.has(cardId)) {
        // Card is flipped, open the link
        openBenefitLink(benefit, eventType, section);
      } else {
        // Card is not flipped, flip it to show details
        toggleCardFlip(benefit, section);
      }
    } else {
      // Desktop: always open link immediately
      openBenefitLink(benefit, eventType, section);
    }
  }

  const videoPlayer = useRef(null);
  function isSupplier() {
    if (cmpData.account_info.membershipLevel === "Premier Supplier") {
      return true;
    } else if (cmpData.account_info.membershipLevel === "Supporting Supplier") {
      return true;
    } else if (cmpData.account_info.membershipLevel === "Supplier") {
      return true;
    } else {
      return false;
    }
  }
  // Fetch benefits data based on active tab
  useEffect(() => {
    // Only fetch if section can load and tab hasn't been loaded yet
    if (cmpData && canSectionLoad('cmp_benefits') && !loadedTabs.includes(activeTab)) {
      let benefitsApiUrl;
      let dataKey;
      
      switch (activeTab) {
        case "key-benefits":
          benefitsApiUrl = cuesURL + "/cmp/benefits?key_only=true";
          dataKey = "keyBenefits";
          break;
        case "all-benefits":
          benefitsApiUrl = cuesURL + "/cmp/benefits";
          dataKey = "allBenefits";
          break;
        case "exclusive-resources":
          benefitsApiUrl = cuesURL + "/cmp/benefits/resources";
          dataKey = "resources";
          break;
        default:
          return;
      }
      
      // Use tabLoading for tab switches, loading for initial load
      if (activeTab === "key-benefits") {
        setLoading(true);
      } else {
        setTabLoading(true);
      }
      
      api.get(benefitsApiUrl)
        .then(function (response) {
          // Update benefitsData with new data for this tab
          setBenefitsData(prevData => ({
            ...prevData,
            [dataKey]: response.data
          }));
          
          // Mark this tab as loaded
          setLoadedTabs(prev => [...prev, activeTab]);
          setLoading(false);
          setTabLoading(false);
          
          // Only mark section as loaded after first load (key-benefits)
          if (activeTab === "key-benefits") {
            markSectionLoaded('cmp_benefits');
          }
        })
        .catch(function (error) {
          setLoading(false);
          setTabLoading(false);
          
          // Mark section as loaded even on error for first load
          if (activeTab === "key-benefits") {
            markSectionLoaded('cmp_benefits');
          }
        });
    } else if (loadedTabs.includes(activeTab)) {
      // Tab already loaded, just set loading to false
      setLoading(false);
      setTabLoading(false);
    }
  }, [cmpData, canSectionLoad, cuesURL, activeTab, loadedTabs, markSectionLoaded]);

  // Update benefits display when benefitsData changes
  useEffect(() => {
    if (benefitsData) {
      switch (activeTab) {
        case "key-benefits":
          if (benefitsData.keyBenefits) {
            setBenefits(benefitsData.keyBenefits);
          }
          break;
        case "all-benefits":
          if (benefitsData.allBenefits) {
            setBenefits(benefitsData.allBenefits);
          }
          break;
        case "exclusive-resources":
          if (benefitsData.resources) {
            setBenefits(benefitsData.resources);
          }
          break;
        default:
          break;
      }
      // Reset flipped cards when switching tabs
      setFlippedCards(new Set());
    }
  }, [benefitsData, activeTab]);

  useEffect(() => {
    // Track when the user plays the key benefits video.
    // const player = new Player(videoPlayer.current);
    // player.on("play", function () {
    //   handleGAEvent("benefits_keybenefitsvideo");
    // });
  }, []);

  return (
    <>
      {!loading && cmpData && (
        <BenefitsElement>
          <div className="cmp-benefits-container">
            {/* Header */}
            <div className="cmp-benefits-header">
              <div className="cmp-benefits-header-content">
                <p>Your Membership Level</p>
                <h2>
                  {cmpData.account_info && cmpData.account_info.membershipLevel
                    ? cmpData.account_info.membershipLevel.split("MVP ").pop()
                    : "N/A"}
                </h2>
              </div>

              <ul className="cmp-benefits-tabs">
                <li>
                  <button
                    className={activeTab == "key-benefits" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("key-benefits");
                    }}
                  >
                    Key Benefits
                  </button>
                </li>
                {!isSupplier() && (
                  <li>
                    <button
                      className={activeTab == "all-benefits" ? "active" : ""}
                      onClick={() => {
                        setActiveTab("all-benefits");
                      }}
                    >
                      All{" "}
                      {cmpData.account_info.membershipLevel &&
                        cmpData.account_info.membershipLevel
                          .split("MVP ")
                          .pop()}{" "}
                      Member Benefits
                    </button>
                  </li>
                )}

                <li>
                  <button
                    className={
                      activeTab == "exclusive-resources" ? "active" : ""
                    }
                    onClick={() => {
                      setActiveTab("exclusive-resources");
                    }}
                  >
                    Exclusive Member Resources
                  </button>
                </li>
              </ul>
            </div>

            {activeTab == "key-benefits" && (
              <>
                {/* Key Benefits Section */}
                <div className="cmp-key-benefits">
                  <div className="cmp-key-benefits-content">
                    <h3>Your Key Benefits</h3>

                    <p >
                      {isSupplier() ? (
                        <>
                          Ready to reach top credit union decision makers? Explore our most popular Supplier Member benefits here.
                        </>
                      ) : (
                        <>
                          Wondering where to start? Easily access our most popular
                          benefits here. Want to see all your benefits? Simply
                          choose the all benefits selection.
                        </>
                      )}

                    </p>
                    <div className="cmp-key-benefits-video-embed"></div>
                    
                    {tabLoading && (
                      <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>Loading benefits...</p>
                      </div>
                    )}

                    {/* {cmpData.account_info.membershipLevel ==
                      "MVP Individual" && (
                        <div className="cmp-key-benefits-video-embed">
                          <iframe
                            ref={videoPlayer}
                            src="https://player.vimeo.com/video/895992968?h=416f17e825"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      )} */}

                    {/* {["MVP Unlimited", "MVP Unlimited+"].indexOf(
                      cmpData.account_info.membershipLevel
                    ) >= 0 && (
                        <div className="cmp-key-benefits-video-embed">
                          <iframe
                            ref={videoPlayer}
                            src="https://player.vimeo.com/video/896009804?h=416f17e825"
                            frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      )} */}
                  </div>

                  <div className="cmp-key-benefits-cards">
                    {!tabLoading && (
                      <ul>
                        {Object.values(benefits).map((benefit, index) => {
                        const uniqueId = `${benefit.title || index}-${index}`;
                        return (
                        <li key={uniqueId}>
                          <div
                            className={`cmp-benefits-card ${isCardFlipped(benefit, "key-benefits") ? "flipped" : ""}`}
                            style={{
                              backgroundImage: benefit.image
                                ? `url('${benefit.image}')`
                                : "none",
                            }}
                            onClick={() => handleCardClick(benefit, "benefits_accesskeybenefits", "key-benefits")}
                          >
                            <p className="cmp-benefits-card-title">
                              {benefit.title}
                            </p>
                            <p className="cmp-benefits-card-description">
                              {benefit.description}
                            </p>
                            {benefit.linkType === "external_link" && (
                              <a
                                href={typeof benefit.link === 'string' ? benefit.link.replace("internal:", "") : benefit.link}
                                target={typeof benefit.link === 'string' && !benefit.link.startsWith('internal:#') ? "_blank" : ""}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGAEvent(
                                    "benefits_accesskeybenefits",
                                    benefit.title
                                  );
                                  // Unflip card on mobile after link opens
                                  if (isMobile) {
                                    unflipCard(benefit, "key-benefits");
                                  }
                                }}
                              >
                                Access{" "}
                                <img src={iconDiagonalArrow} class="access" alt="Visit CUES.net" />
                              </a>
                            )}
                            {benefit.linkType === "download_link" && (
                              <a
                                href={benefit.file}
                                target="_blank"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGAEvent(
                                    "benefits_accesskeybenefits",
                                    benefit.title
                                  );
                                  // Unflip card on mobile after link opens
                                  if (isMobile) {
                                    unflipCard(benefit, "key-benefits");
                                  }
                                }}
                              >
                                Download{" "}
                                <img
                                  src={iconArrowDown}
                                  alt="Download Resource"
                                />
                              </a>
                            )}
                            {benefit.linkType === "contact_link" && (
                              <a
                                href={`mailto:` + benefit.contact}
                                target="_blank"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGAEvent(
                                    "benefits_accesskeybenefits",
                                    benefit.title
                                  );
                                  // Unflip card on mobile after link opens
                                  if (isMobile) {
                                    unflipCard(benefit, "key-benefits");
                                  }
                                }}
                              >
                                Contact Us{" "}
                                <img
                                  src={iconEmail} className="email"
                                  alt="Download Resource"
                                />
                              </a>
                            )}
                          </div>
                        </li>
                        );
                        })}
                      </ul>
                    )}
                  </div>
                </div>
              </>
            )}

            {activeTab == "all-benefits" && (
              <>
                {/* All Benefits Section */}
                <div className="cmp-all-benefits">
                  {tabLoading ? (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                      <p>Loading benefits...</p>
                    </div>
                  ) : (
                    <>
                      <Swiper
                      simulateTouch={false}
                      slidesPerView={1}
                      grid={{
                        rows: 2,
                      }}
                      spaceBetween={30}
                      onSwiper={(swiper) => setCurrentSwiper(swiper)}

                      // pagination={{
                      //   clickable: true,
                      // }}
                      pagination={{
                        clickable: true,
                        renderBullet: function (index, className) {
                          return ``;
                        }
                      }}
                      modules={[Grid, Pagination]}
                      className="mySwiper"
                      breakpoints={{
                        500: {
                          slidesPerView: 2,
                          slidesPerGroup: 2,
                        },
                        900: {
                          slidesPerView: 3,
                          slidesPerGroup: 3,
                        },
                      }}
                    >
                      {Object.values(benefits).map((benefit) => (
                        <SwiperSlide key={benefit.title}>
                          <div
                            className={`cmp-benefits-card ${isCardFlipped(benefit, "all-benefits") ? "flipped" : ""}`}
                            style={{
                              backgroundImage: benefit.image
                                ? `url('${benefit.image}')`
                                : "none",
                            }}
                            onClick={() => handleCardClick(benefit, "benefits_allbenefits", "all-benefits")}
                          >
                            <p className="cmp-benefits-card-title">
                              {benefit.title}
                            </p>
                            <p className="cmp-benefits-card-description">
                              {benefit.description}
                            </p>

                            {benefit.linkType === "external_link" && (
                              <a
                                href={typeof benefit.link === 'string' ? benefit.link.replace("internal:", "") : benefit.link}
                                target={typeof benefit.link === 'string' && !benefit.link.startsWith('internal:#') ? "_blank" : ""}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGAEvent(
                                    "benefits_allbenefits",
                                    benefit.title
                                  );
                                  // Unflip card on mobile after link opens
                                  if (isMobile) {
                                    unflipCard(benefit, "all-benefits");
                                  }
                                }}
                              >
                                Access{" "}
                                <img src={iconDiagonalArrow} class="access" alt="Visit CUES.net" />
                              </a>
                            )}
                            {benefit.linkType === "download_link" && (
                              <a
                                href={benefit.file}
                                target="_blank"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGAEvent(
                                    "benefits_allbenefits",
                                    benefit.title
                                  );
                                  // Unflip card on mobile after link opens
                                  if (isMobile) {
                                    unflipCard(benefit, "all-benefits");
                                  }
                                }}
                              >
                                Download{" "}
                                <img
                                  src={iconArrowDown}
                                  alt="Download Resource"
                                />
                              </a>
                            )}
                            {benefit.linkType === "contact_link" && (
                              <a
                                href={`mailto:` + benefit.contact}
                                target="_blank"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleGAEvent(
                                    "benefits_allbenefits",
                                    benefit.title
                                  );
                                  // Unflip card on mobile after link opens
                                  if (isMobile) {
                                    unflipCard(benefit, "all-benefits");
                                  }
                                }}
                              >
                                Contact Us{" "}
                                <img
                                  src={iconEmail} className="email"
                                  alt="Download Resource"
                                />
                              </a>
                            )}
                          </div>
                        </SwiperSlide>
                      ))}
                      </Swiper>
                      <SwiperPager swiper={currentSwiper} itemCount={benefits.length} pageRangeCount={8}
                        itemsPerPage={6} currentPage={0}></SwiperPager>
                    </>
                  )}
                </div>
              </>
            )}

            {activeTab == "exclusive-resources" && (
              <>
                {/* Member Resources Section */}
                <div className="cmp-member-resources">
                  <div className="cmp-member-resource-cards">
                    {tabLoading ? (
                      <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>Loading resources...</p>
                      </div>
                    ) : (
                      <>
                        {/* All Benefits Section */}
                        <div className="cmp-all-benefits">
                          <>
                            <Swiper
                            simulateTouch={false}
                            slidesPerView={1}
                            grid={{
                              rows: 2,
                            }}
                            spaceBetween={30}
                            onSwiper={(swiper) => setCurrentSwiper(swiper)}

                            // pagination={{
                            //   clickable: true,
                            // }}
                            pagination={{
                              clickable: true,
                              renderBullet: function (index, className) {
                                return ``;
                              }
                            }}
                            modules={[Grid, Pagination]}
                            className="mySwiper"
                            breakpoints={{
                              500: {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                              },
                              900: {
                                slidesPerView: 3,
                                slidesPerGroup: 3,
                              },
                            }}
                          >
                            {Object.values(benefits).map((benefit) => (
                              <SwiperSlide key={benefit.title}>
                                <div 
                                  className="cmp-member-resource-card"
                                  onClick={() => handleCardClick(benefit, "benefits_resources", "exclusive-resources")}
                                >
                                  {benefit.image && (
                                    <img
                                      src={benefit.image}
                                      className="cmp-member-resource-card-icon"
                                      alt="Member Resource Icon"
                                    />
                                  )}
                                  <p className="cmp-member-resource-card-title">
                                    {benefit.title}
                                  </p>

                                  {benefit.description && (
                                    <p className="cmp-member-resource-card-description">
                                      {benefit.description}
                                    </p>
                                  )}

                                  {benefit.linkType === "external_link" && (
                                    <a href={typeof benefit.link === 'string' ? benefit.link.replace("internal:", "") : benefit.link}
                                      target={typeof benefit.link === 'string' && !benefit.link.startsWith('internal:#') ? "_blank" : ""}                                       onClick={(e) => {
                                        e.stopPropagation();
                                        handleGAEvent(
                                          "benefits_resources",
                                          benefit.title
                                        );
                                        // Unflip card on mobile after link opens
                                        if (isMobile) {
                                          unflipCard(benefit, "exclusive-resources");
                                        }
                                      }}>
                                      {benefit.title ==
                                        "Board Governance Assessment" ? (
                                        <>
                                          Access{" "}
                                          <img
                                            src={iconArrowDown}
                                            alt="Download Resource"
                                          />
                                        </>
                                      ) : (
                                        <>
                                          ACCESS{" "}
                                          <img
                                            src={iconDiagonalArrow} class="access"
                                            alt="Download Resource"
                                          />
                                        </>
                                      )}
                                    </a>
                                  )}

                                  {/* Only use the file download link if resource link field is null. */}
                                  {benefit.linkType === "download_link" && benefit.file && (
                                    <a
                                      href={benefit.file}
                                      target="_blank"
                                      download
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleGAEvent(
                                          "benefits_resources",
                                          benefit.title
                                        );
                                        // Unflip card on mobile after link opens
                                        if (isMobile) {
                                          unflipCard(benefit, "exclusive-resources");
                                        }
                                      }}
                                    >
                                      {benefit.title ==
                                        "Board Governance Assessment" ? (
                                        <>
                                          Access{" "}
                                          <img
                                            src={iconArrowDown}
                                            alt="Download Resource"
                                          />
                                        </>
                                      ) : (
                                        <>
                                          Download{" "}
                                          <img
                                            src={iconArrowDown}
                                            alt="Download Resource"
                                          />
                                        </>
                                      )}
                                    </a>
                                  )}
                                  {/* Only use the file download link if resource link field is null. */}
                                  {benefit.linkType === "contact_link" && (
                                    <a
                                      href={`mailto:` + benefit.contact}
                                      target="_blank"
                                      download
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleGAEvent(
                                          "benefits_resources",
                                          benefit.title
                                        );
                                        // Unflip card on mobile after link opens
                                        if (isMobile) {
                                          unflipCard(benefit, "exclusive-resources");
                                        }
                                      }}
                                    >
                                      Contact Us{" "}
                                      <img
                                        src={iconEmail} className="email"
                                        alt="Download Resource"
                                      />

                                    </a>
                                  )}
                                </div>
                              </SwiperSlide>
                            ))}
                            </Swiper>
                            <SwiperPager swiper={currentSwiper} itemCount={benefits.length} pageRangeCount={8}
                              itemsPerPage={6} currentPage={0}></SwiperPager>
                          </>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </BenefitsElement>
      )}
    </>
  );
};

export default Benefits;
